module.exports = __webpack_public_path__ + "img/aef0da9ed44f42be8c85ccae93318680.png";